import { ResumeDto } from "@reactive-resume/dto";
import { useState } from "react";

import { kyParent } from "../libs/ky";
import { useOpenAiStore } from "../stores/openai";

const useAjaxPdfDownload = () => {
  const [loading, setLoading] = useState(false);
  const apiKey = useOpenAiStore().apiKey;
  const download = async (resumeData: ResumeDto) => {
    setLoading(true);
    let result: string | null = null;
    const url = `api/pdf-download`;
    try {
      const res = await kyParent
        .post(url, {
          json: {
            data: resumeData,
            // eslint-disable-next-line lingui/no-unlocalized-strings
            apiKey: apiKey,
          },
        })
        .json<{ url: string }>();
      result = res.url;
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
    return result;
  };

  return {
    loading,
    download,
  };
};
export default useAjaxPdfDownload;
